
import React from "react";
import { useOptimizedMedia } from "./useOptimizedMedia";

const Image = ({ src, alt, width, height }) => {
  const optimizedSrc = useOptimizedMedia(src, width, height);
  return <img src={optimizedSrc} alt={alt} width={width} height={height} loading="lazy" style={{borderRadius: '5px'}} />;
};

export default Image;
